<template>
    <div class="visitApply">
      <van-nav-bar fixed>
        <div slot="left" @click="close">
          <van-icon name="arrow-left" color="#333" class="icon-title-size" />
        </div>
        <div slot="title" class="all-title">访客申请</div>
      </van-nav-bar>
      <div class="visit-apply-from">
        <van-cell-group>
            <van-field v-model="vPhone" @input="onInputPhone()" label="手机号码" placeholder="请输入您的手机号码" />
            <van-field v-model="vIdentity"  label="身份证" placeholder="请输入您的身份证号" />
            <SingleBottomBtn @clickBtn="onSubmit">下一步</SingleBottomBtn>
        </van-cell-group>
      </div>
      <p class="tips-p">注意提示：请您填写正确的手机号和身份证号，方便您下次登录</p>
    </div>
</template>
<script>
import SingleBottomBtn from "../../../attendance/components/SingleBottomBtn";
export default {
    name: 'visitApply',
    data() {
        return {
            vPhone:'',
            vIdentity:'',
            VisitorID:0,
            isSecond:false,
            thisUserInfo:{},
            accountId:0
        };
    },
    created(){
       this.accountId = localStorage.getItem('accountId')
    },
    components: {
        SingleBottomBtn
     },
    methods:{
        close(){
           this.$router.go(-1) 
        },
        //输入触发
        onInputPhone:function(){
            if (this.vPhone === '' || !(/^1[3456789]\d{9}$/.test(this.vPhone))) {
                this.vIdentity = ''
                return false;
            }else{
             this.getVisitorInfo()
            }
         },
        async getVisitorInfo(){
            let res = await this.xyapi.get(this.xyMApi+'/vst' + "/visitor/GetVisitorIdCard", {'PhoneNumber':this.vPhone,'AccountId': Number(this.accountId)});
            if(res !== undefined && res.success){
                this.vIdentity = res.data
            }
        },
       async onSubmit() {
            if (this.vPhone === '' || !(/^1[3456789]\d{9}$/.test(this.vPhone))) {
                this.xy.msgError('请输入正确手机号');
                return false;
            }
           if (
                this.vIdentity === "" ||
                !/^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/.test(
                this.vIdentity
                )
            ) {
                this.xy.msgError("请输入正确身份证号");
                return false;
            }
            console.log(this.isSecond)
            let res = await this.xyapi.get(this.xyMApi+'/vst' + "/visitor/GetVisitorInfo", {'PhoneNumber':this.vPhone,'IdCard':this.vIdentity,'AccountId': Number(this.accountId)});
            console.log(res)
            this.thisUserInfo = res.data
            //是否第一次登陆访客
            if(res !== undefined && res.success){
                if(this.thisUserInfo === null){  
                    //第一次访问
                 this.VisitorID = 0
                 this.$router.push({
                        path:'/home/visitApply',
                        query: {
                            VisitorPhoneNumber:this.vPhone,
                            VisitorIdCard:this.vIdentity,
                            VisitorName:this.thisUserInfo ? this.thisUserInfo.FullName : '',
                            Sex:this.thisUserInfo ? this.thisUserInfo.Sex : '',
                            VisitorID:this.VisitorID,
                            Address:this.thisUserInfo ? this.thisUserInfo.Address : '',
                            isSecond:this.isSecond
                        }
                    })
                }else{  
                    //账号存在
                     if(this.thisUserInfo.RoleName === '家长'){
                            this.$router.push({
                                path:'/home/VisitSubmission',
                                query: {
                                    isFrom:'家长'
                                }
                            })
                    }else{
                        this.isSecond = true
                        this.$router.push({
                            path:'/home/visitApply',
                            query: {
                                VisitorPhoneNumber:this.vPhone,
                                VisitorIdCard:this.vIdentity,
                                VisitorName:this.thisUserInfo ? this.thisUserInfo.FullName : '',
                                Sex:this.thisUserInfo ? this.thisUserInfo.Sex : '',
                                VisitorID:this.thisUserInfo ? this.thisUserInfo.UserId : '',
                                Address:this.thisUserInfo ? this.thisUserInfo.Address : '',
                                isSecond:this.isSecond
                            }
                        })
                    }
                }
            }
        },
    }
}
</script>
<style lang="less" scoped>
.visitApply{
    background-color: #ffffff;
    .tips-p{
        margin:3.8vw;
        background-color: #f9f9f9!important;
        font-size:3.2vw;
    }
    .visit-explain{
        background-color: #F7F7F7;
        width: 92%;
        margin-left: 4%;
    }
    .visit-apply-from{
      margin-top: 15%;
    }
}   
.icon-title-size{
  font-size: 38px;
}
</style>